module.exports = __webpack_public_path__ + "media/share/filled@2x-d6bcf8ed.png";